import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Signature({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M13.5096 19H19.5096M3.53469 8.05078C3.17875 7.45535 2.9938 6.77335 3.00014 6.07968C2.85743 4.54411 3.96803 3.176 5.50014 3C8.26156 3 10.5001 7.02944 10.5001 12C10.5001 16.9706 8.48542 21 6.00014 21H6.0022C4.62035 21 3.50014 19.2091 3.50014 17C3.50101 14.8774 4.34505 12.8421 5.84657 11.3418C7.3481 9.84149 9.38411 8.99913 11.5067 9H11.5001C13.5672 9.14749 15.1291 10.9333 15.0001 13.0016C14.9901 14.021 14.821 15.0327 14.499 16H14.5001C16.2995 10.5865 18.0008 10 19.0006 10C19.5309 10.0001 20.0396 10.2108 20.4146 10.5859C20.7896 10.9609 21.0002 11.4696 21.0001 12" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Signature;